import React, { useState, useEffect } from 'react';
import {
  useHistory,
  useParams
} from 'react-router-dom';
import { useAppContext, useLocaleContext, useTransactionContext } from 'context';
import { APP_STEPS, TRANSACTION_STATES } from 'constants.js';
import Error from './Error';
import Success from './Success';
import Rejected from './Rejected';
import clsx from 'clsx';
import styles from './Finish.module.css';

const ALLOWED_STATUS = [
  TRANSACTION_STATES.SUCCESS,
  TRANSACTION_STATES.REJECTED,
  TRANSACTION_STATES.ERROR,
  TRANSACTION_STATES.EXPIRED
];

const Finish = ({ className, forceStatus }) => {

  const { id } = useParams();
  const history = useHistory();
  const [ status, setStatus ] = useState();

  const { transaction: { state } } = useTransactionContext();
  const {
    availableLanguages,
    locale,
    setDefaultLocale
  } = useLocaleContext();

  const {
    isLoading,
    setIsLoading,
    setAppStep
  } = useAppContext();

  useEffect(() => {
    if (!locale && availableLanguages) {
      setDefaultLocale();
    }
    if (locale && isLoading) {
      setIsLoading(false);
    }
  }, [ availableLanguages, setDefaultLocale, locale, isLoading, setIsLoading ]);

  useEffect(() => {
    if (forceStatus && ALLOWED_STATUS.includes(forceStatus)) {
      setStatus(forceStatus);
    } else if (state) {
      const split = history.location.pathname.split('/');
      const _status = split[split.length - 1];

      if (ALLOWED_STATUS.includes(_status)) {
        if (state === TRANSACTION_STATES.FINISHED) {
          setStatus(_status);
        } else if (window.sessionStorage.getItem('manual-error')) {
          setStatus(TRANSACTION_STATES.ERROR);
        } else {
          setAppStep(APP_STEPS.ORDER_SUMMARY);
        }
      } else {
        setStatus(TRANSACTION_STATES.ERROR);
      }
    } else {
      setStatus(TRANSACTION_STATES.ERROR);
    }
  }, [ forceStatus, status, state, id, history, setAppStep ]);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return !isLoading ? (
    <div className={clsx(styles.root, className)}>
      <div className={styles.container}>
        {status === TRANSACTION_STATES.ERROR && <Error />}
        {status === TRANSACTION_STATES.SUCCESS && <Success />}
        {status === TRANSACTION_STATES.REJECTED && <Rejected />}
      </div>
    </div>
  ) : <div />;
};

export default Finish;
